const minoLayers = [
    {
      id: 'EPN',
      src: '/animation_assets/30_mino_EPN.png',
      width: '153.6px',
      height: '132.4px',
      left: '35.1%',
      top: '27.8%',
      zIndex: 8,
      alt: 'Simple graphic of a white flower',
      role: 'primary',
      group: 0,
      orientation: 'front'
    },
    {
      id: 'RAZ',
      src: '/animation_assets/30_mino_RAZ.png',
      width: '219.1px',
      height: '102.0px',
      left: '28.7%',
      top: '54.4%',
      zIndex: 7,
      alt: 'mino', 
      role: 'text',
      group: 0,
    },
    {
      id: 'OUH',
      src: '/animation_assets/30_mino_OUH.png',
      width: '69.8px',
      height: '17.8px',
      left: '30.6%',
      top: '70.8%',
      zIndex: 6,
      alt: 'ceramics',
      role: 'text',
      group: 0,
    },
    {
      id: 'WPI',
      src: '/animation_assets/30_mino_WPI.png',
      width: '512.0px',
      height: '512.0px',
      left: '0.0%',
      top: '-0.0%',
      zIndex: 5,
      alt: 'Solid orange color square',
      role: 'background',
      group: 0
    }
  ];

  export default minoLayers;
  